import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetPortalUsuarioEmpresa, IGetUsuarioEmpresa } from '../../shared/interfaces/database/seguridad';

@Injectable({
  providedIn: 'root'
})
export class PortalUsuarioEmpresaService {
  private readonly baseUrl = `${environment.apiUrl}/api/portal-usuario-empresa`;

  constructor(private readonly http: HttpClient) { }

  public getUsuarioEmpresa(portalUsuarioId: number): Observable<IGetUsuarioEmpresa> {
    return this.http.get<IGetUsuarioEmpresa>(`${this.baseUrl}/${portalUsuarioId}`);
  }

  public downloadEmpresaDocumento(empresaId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar-documento/${empresaId}`, { responseType: 'blob' });
  }

  public getPortalUsuarioEmpresa(portalUsuarioId: number): Observable<IGetPortalUsuarioEmpresa[]> {
    return this.http.get<IGetPortalUsuarioEmpresa[]>(`${this.baseUrl}/empresas/${portalUsuarioId}`);
  }
}
